{
	"title": "{{productName}} historial de transacciones",
	"item": {
		"time": "Tiempo",
		"description": "Descripción",
		"transactionId": "ID de transacción",
		"showIds": "Mostrar IDs",
		"depositTitle": "Garantía por parte de DNV, que permite un depósito bancario de carbono.",
		"depositDescription": "Una vez que el organismo de aseguramiento externo 'DNV' ha asegurado el volumen de carbono capturado almacenado en un sistema digital Monitor-Report-Verify, se realiza un nuevo depósito en el banco de carbono.",
		"withdrawalTitle": "Factura al proveedor, lo que provoca un retiro del banco de carbono",
		"withdrawalDescription": "Con la facturación del material evoZero al proveedor se ha ejecutado una baja del banco de carbono.",
		"transferTitle": "Transferencia de reducciones de carbono al titular de la declaración",
		"transferDescription": "El proveedor inició la transferencia de las reducciones de carbono al titular de la declaración, en función del volumen de material evoZero que entró en el producto entregado."
	},
	"proofIdsModal": {
		"titleTransactions": "Ver transacciones",
		"titleMeasurements": "Ver mediciones",
		"paragraph1": "Un paso de transacción en {{productName}} implica agregar transacciones en el libro mayor distribuido. A continuación, encontrará una lista de enlaces a servicios de terceros donde puede ver estas transacciones.",
		"paragraph2": "Tenga en cuenta que estos enlaces lo llevarán a sitios web externos que brindan capacidades de visualización de transacciones.",
		"open": "Abrir",
		"close": "Cerrar"
	},
	"errors": {
		"fetch": "No se pudo recuperar el historial de actividad"
	}
}
